import { Autocomplete, Button, Field, Text, TextField } from "components/commons";
import locale from "localization";
import styles from "./delivery-log.module.scss";
import { useFormContext } from "contexts/form-context";
import { useDynamicFieldsForm } from "hooks";
import Validation from "utils/validation.utils";
import { Add } from "@material-ui/icons";
import EmployeePositionEnum from "enums/employee-position";
import { prettifyEmployeePosition } from "utils/pretty.utils";
import { MAX_SHORT_TEXT } from "data/constant/form";
import { useEffect } from "react";
import CloseIcon from "@material-ui/icons/Close";
const WitnessInformation = (props, ref) => {
  const {
    setSubFormsSubmittableState,
    modifyField: modifyFieldRoot,
    initialState,
    fields: rootFields,
  } = useFormContext();
  const { fieldsAsRows, addRow, modifyField, addRows, modifyForm, removeRow } =
    useDynamicFieldsForm({
      rowId: "witnessId",
      onChangeIsSubmittable: ({ isFormSubmittable, rowsValues }) => {
        setSubFormsSubmittableState((f) => ({ ...f, witness: isFormSubmittable }));
        modifyFieldRoot("witness", {
          value: rowsValues,
        });
      },
    });

  const positionOption = [
    {
      value: EmployeePositionEnum.STATION_HEAD,
      label: prettifyEmployeePosition(EmployeePositionEnum.STATION_HEAD),
    },
    {
      value: EmployeePositionEnum.STATION_CREW,
      label: prettifyEmployeePosition(EmployeePositionEnum.STATION_CREW),
    },
    {
      value: EmployeePositionEnum.CASHIER,
      label: prettifyEmployeePosition(EmployeePositionEnum.CASHIER),
    },
    {
      value: EmployeePositionEnum.SECURITY_GUARD,
      label: prettifyEmployeePosition(EmployeePositionEnum.SECURITY_GUARD),
    },
    {
      value: EmployeePositionEnum.SERVICE_ADVISOR,
      label: prettifyEmployeePosition(EmployeePositionEnum.SERVICE_ADVISOR),
    },
    {
      value: EmployeePositionEnum.TECHNICIAN,
      label: prettifyEmployeePosition(EmployeePositionEnum.TECHNICIAN),
    },
  ];

  const formState = {
    witnessId: {
      name: "witnessId",
      value: Math.floor(Math.random() * 1000),
      required: false,
      validations: [],
    },
    witness: {
      name: "witness",
      value: "",
      label: locale.witness,
      placeholder: locale.enterName,
      required: true,
      maxLength: MAX_SHORT_TEXT,
      validations: [Validation.required({ noMessage: true })],
    },
    position: {
      name: "position",
      value: "",
      label: locale.position,
      placeholder: locale.select,
      required: true,
      validations: [Validation.required({ noMessage: true })],
    },
  };

  const handleAddWitness = () => {
    addRow([formState.witness, formState.position]);
  };

  useEffect(() => {
    const witnesses = initialState?.witness?.value;
    if (witnesses?.length > 0) {
      addRows(
        witnesses.map(({ witness, position }) => [
          {
            ...formState.witness,
            value: witness,
          },
          {
            ...formState.position,
            value: position,
          },
        ])
      );
    } else {
      addRow([
        formState.witness,
        {
          ...formState.position,
          value: EmployeePositionEnum.CASHIER,
        },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialState?.witness?.value]);

  useEffect(() => {
    if (rootFields?.cashier?.value) {
      modifyForm({
        "witness-0": {
          value: rootFields?.cashier?.value,
        },
        "position-0": {
          value: EmployeePositionEnum.CASHIER,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rootFields?.cashier?.value]);

  return (
    <>
      <Text strong color={"black"} className={styles.sectionTitle}>
        {locale.witnessInformation}
      </Text>
      <br />
      <div className={styles.witness}>
        {fieldsAsRows.map(({ witness, position }, index) => (
          <>
            <div key={index + witness + position} className={styles.row}>
              <Field
                {...witness}
                label={index === 0 && witness?.label}
                labelClassName={styles.fieldLabel}
                childrenClassName={styles.fieldContent}
              >
                <TextField {...witness} onChange={modifyField} />
              </Field>
              <Field
                {...position}
                label={index === 0 && position?.label}
                labelClassName={styles.fieldLabel}
                childrenClassName={styles.fieldContent}
              >
                <Autocomplete {...position} options={positionOption} onChange={modifyField} />
              </Field>
            </div>
            {index > 0 ? (
              <div className={styles.circleIcon} onClick={() => removeRow(index)}>
                <CloseIcon style={{ fontSize: "14px" }} />
              </div>
            ) : (
              <div></div>
            )}
          </>
        ))}
      </div>
      <br />
      <Button primary className={styles.palePurpleButton} onClick={handleAddWitness}>
        <div className={styles.btn}>
          <Add fontSize="small" /> {locale.addWitness}
        </div>
      </Button>
    </>
  );
};

export default WitnessInformation;
